import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from '@mui/material';

import type { HowItWorksStep } from 'features/producer-buyer-portal/shared/how-it-works-steps';

import { STEP_INTRO_PROCESSOR, StepIntro } from './step-intros';

export interface ProcessorOption {
  vendorId: string;
  shopName: string;
}

export function ProcessorSelectionStep({
  processors,
  selectedVendorId,
  onSelect,
  stepNumber = 1,
  intro = STEP_INTRO_PROCESSOR,
  prompt = 'Choose which processor you’d like to schedule with.',
}: {
  processors: ProcessorOption[];
  selectedVendorId?: string;
  /** Called with the chosen vendorId. The caller is responsible for advancing the step. */
  onSelect: (vendorId: string) => void;
  /** This step's position in the wizard, for its explainer panel. */
  stepNumber?: number;
  /** The explainer panel; the scheduling one unless the wizard says otherwise. */
  intro?: HowItWorksStep;
  /** The line over the list, for a wizard that isn't scheduling. */
  prompt?: string;
}) {
  return (
    <Stack spacing={2}>
      <StepIntro intro={intro} number={stepNumber} />

      <Typography variant="body2" color="text.secondary">
        {prompt}
      </Typography>
      <FormControl>
        <RadioGroup
          value={selectedVendorId ?? ''}
          onChange={(e) => onSelect(e.target.value)}
        >
          {processors.map((p) => (
            <FormControlLabel
              key={p.vendorId}
              value={p.vendorId}
              control={<Radio />}
              label={p.shopName}
              // A radio row in a modal on a phone is a ~38px target by
              // default; the list is the whole step, so it gets thumb-sized.
              sx={{
                py: 0.75,
                '& .MuiFormControlLabel-label': { fontSize: '1rem' },
              }}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </Stack>
  );
}
